<template>
  <v-card class="mx-auto" :loading="ldg" :disabled="ldg">
    <v-card-title>
      <v-row dense>
        <v-col cols="12">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                small
                plain
                icon
                :to="{
                  name: 'providers.view',
                  params: { id: id },
                }"
              >
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
            </template>
            <span v-text="'Átras'" />
          </v-tooltip>
          <span class="text-h6 ml-1" v-text="$route.meta.title" />
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text v-if="data">
      <v-row>
        <v-col cols="12">
          <v-row>
            <v-col cols="12">
              <v-card class="mx-auto">
                <v-card-title>
                  <h2 class="text-caption">
                    IDP {{ data.id }} |
                    {{ data.name }}
                  </h2>
                </v-card-title>
                <v-divider />
                <v-card-text>
                  <v-row dense>
                    <v-col cols="12">
                      <v-btn
                        icon
                        x-small
                        @click="data.rhas_show = !data.rhas_show"
                      >
                        <v-icon x-small>
                          mdi-chevron-{{ data.rhas_show ? "down" : "up" }}
                        </v-icon>
                      </v-btn>
                      Ingresos ({{ data.rhas.length }}) |
                      <small class="green--text">
                        Activos ({{ data.rhas_active }})
                      </small>
                      |
                      <small class="red--text">
                        Inactivos ({{ data.rhas_inactive }})
                      </small>
                    </v-col>
                    <v-col cols="12" v-if="data.rhas_show">
                      <div v-for="(rha, k) in data.rhas" :key="k">
                        <small :class="rha.active ? '' : 'red--text'">
                          {{ rha.key + 1 }}. {{ rha.folio }}
                        </small>
                      </div>
                    </v-col>
                    <v-col cols="12">
                      <v-divider />
                    </v-col>
                    <v-col cols="12">
                      <v-btn
                        icon
                        x-small
                        @click="data.rs_services_show = !data.rs_services_show"
                      >
                        <v-icon x-small>
                          mdi-chevron-{{
                            data.rs_services_show ? "down" : "up"
                          }}
                        </v-icon>
                      </v-btn>
                      Servicios ({{ data.rs_services.length }}) |
                      <small class="green--text">
                        Activos ({{ data.rs_services_active }})
                      </small>
                      |
                      <small class="red--text">
                        Inactivos ({{ data.rs_services_inactive }})
                      </small>
                    </v-col>
                    <v-col cols="12" v-if="data.rs_services_show">
                      <div v-for="(rs_service, k) in data.rs_services" :key="k">
                        <small :class="rs_service.active ? '' : 'red--text'">
                          {{ rs_service.key + 1 }}.
                          {{ rs_service.folio }}
                        </small>
                      </div>
                    </v-col>
                    <v-col cols="12">
                      <v-divider />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12">
              <template>
                <v-stepper v-model="step" vertical>
                  <v-stepper-step :complete="step > 1" step="1">
                    Seleccionar
                  </v-stepper-step>

                  <v-stepper-content step="1">
                    <v-row class="pt-2">
                      <v-col cols="12">
                        <v-autocomplete
                          label="Proveedor(es)"
                          v-model="provider_ids"
                          :items="providers"
                          :loading="providers_ldg"
                          item-value="id"
                          :item-text="(v) => `IDP ${v.id} | ${v.name}`"
                          dense
                          multiple
                        />
                      </v-col>
                      <v-col cols="6" />
                      <v-col cols="6">
                        <v-btn
                          block
                          small
                          color="primary"
                          :disabled="provider_ids.length == 0"
                          @click="getItemsRhasRsServices()"
                          :loading="ldg"
                        >
                          Continuar
                          <v-icon right>mdi-chevron-right</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-stepper-content>

                  <v-stepper-step :complete="step > 2" step="2">
                    Detalle de regs. a asignar
                  </v-stepper-step>

                  <v-stepper-content step="2">
                    <v-row>
                      <v-col
                        v-for="(provider_data, i) in providers_data"
                        :key="i"
                        cols="12"
                      >
                        <v-card class="mx-auto">
                          <v-card-title>
                            <h2 class="text-caption">
                              IDP {{ provider_data.id }} |
                              {{ provider_data.name }}
                            </h2>
                          </v-card-title>
                          <v-divider />
                          <v-card-text>
                            <v-row dense>
                              <v-col cols="12">
                                <v-btn
                                  icon
                                  x-small
                                  @click="
                                    provider_data.rhas_show = !provider_data.rhas_show
                                  "
                                >
                                  <v-icon x-small>
                                    mdi-chevron-{{
                                      provider_data.rhas_show ? "down" : "up"
                                    }}
                                  </v-icon>
                                </v-btn>
                                Ingresos ({{ provider_data.rhas.length }}) |
                                <small class="green--text">
                                  Activos ({{ provider_data.rhas_active }})
                                </small>
                                |
                                <small class="red--text">
                                  Inactivos ({{ provider_data.rhas_inactive }})
                                </small>
                              </v-col>
                              <v-col cols="12" v-if="provider_data.rhas_show">
                                <div
                                  v-for="(rha, k) in provider_data.rhas"
                                  :key="k"
                                >
                                  <small :class="rha.active ? '' : 'red--text'">
                                    {{ rha.key + 1 }}. {{ rha.folio }}
                                  </small>
                                </div>
                              </v-col>
                              <v-col cols="12">
                                <v-divider />
                              </v-col>
                              <v-col cols="12">
                                <v-btn
                                  icon
                                  x-small
                                  @click="
                                    provider_data.rs_services_show = !provider_data.rs_services_show
                                  "
                                >
                                  <v-icon x-small>
                                    mdi-chevron-{{
                                      provider_data.rs_services_show
                                        ? "down"
                                        : "up"
                                    }}
                                  </v-icon>
                                </v-btn>
                                Servicios ({{
                                  provider_data.rs_services.length
                                }}) |
                                <small class="green--text">
                                  Activos ({{
                                    provider_data.rs_services_active
                                  }})
                                </small>
                                |
                                <small class="red--text">
                                  Inactivos ({{
                                    provider_data.rs_services_inactive
                                  }})
                                </small>
                              </v-col>
                              <v-col
                                cols="12"
                                v-if="provider_data.rs_services_show"
                              >
                                <div
                                  v-for="(rs_service,
                                  k) in provider_data.rs_services"
                                  :key="k"
                                >
                                  <small
                                    :class="
                                      rs_service.active ? '' : 'red--text'
                                    "
                                  >
                                    {{ rs_service.key + 1 }}.
                                    {{ rs_service.folio }}
                                  </small>
                                </div>
                              </v-col>
                              <v-col cols="12">
                                <v-divider />
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <v-col cols="6">
                        <v-btn
                          block
                          small
                          @click="
                            step = 1;
                            providers_data = [];
                          "
                        >
                          <v-icon left>mdi-chevron-left</v-icon>
                          Átras
                        </v-btn>
                      </v-col>
                      <v-col cols="6">
                        <v-btn
                          block
                          small
                          color="success"
                          @click="setItemsRhasRsServices"
                          :disabled="providers_data.length == 0"
                          :loading="ldg"
                        >
                          Asignar
                          <v-icon right>mdi-check</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-stepper-content>
                </v-stepper>
              </template>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import Axios from "axios";
import {
  URL_API,
  headersToken,
  msgAlert,
  rules,
  msgConfirm,
} from "../../control";
import ViewData from "../../components/ViewData.vue";

export default {
  components: {
    ViewData,
  },
  data() {
    return {
      id: this.$route.params.id,
      login: this.$store.getters.getLogin,
      ldg: false,
      data: null,
      step: 1,
      providers: [],
      providers_ldg: true,
      provider_ids: [],
      providers_data: [],
    };
  },
  methods: {
    getCatalogs() {
      Axios.get(
        URL_API + "/providers/not_id/" + this.id,
        headersToken(this.login.token)
      ).then((resp) => {
        this.providers = resp.data.data;
        this.providers_ldg = false;
      });
    },
    getData() {
      this.ldg = true;

      Axios.get(
        URL_API + "/providers/rhas_rs_services/" + this.id,
        headersToken(this.login.token)
      ).then((res) => {
        this.data = res.data.data;
        this.ldg = false;
      });
    },
    getItemsRhasRsServices() {
      this.ldg = true;

      Axios.get(
        URL_API +
          "/providers/rhas_rs_services?provider_ids=" +
          this.provider_ids,
        headersToken(this.login.token)
      )
        .then((res) => {
          this.providers_data = res.data.data.providers_data;
          this.ldg = false;
          this.step = 2;
        })
        .catch((e) => {
          console.log(e);
          this.$swal.fire(
            msgAlert("error", "Error. Contacte al equipo de desarrollo")
          );
          this.ldg = false;
        });
    },
    setItemsRhasRsServices() {
      this.$swal
        .fire(msgConfirm("¿Confirma ejecutar la asignación?"))
        .then((response) => {
          if (response.isConfirmed) {
            this.ldg = true;

            Axios.post(
              URL_API + "/providers/rhas_rs_services",
              {
                id: this.id,
                providers_data: this.providers_data,
              },
              headersToken(this.login.token)
            )
              .then((res) => {
                this.$swal.fire(
                  msgAlert(
                    res.data.success ? "success" : "error",
                    res.data.message
                  )
                );

                if (res.data.success) {
                  this.$router.push({
                    name: "providers.view",
                    params: { id: this.id },
                  });
                }

                this.ldg = false;
              })
              .catch((e) => {
                console.log(e);
                this.$swal.fire(
                  msgAlert("error", "Error. Contacte al equipo de desarrollo")
                );

                this.ldg = false;
              });
          }
        });
    },
  },
  mounted() {
    this.getCatalogs();
    this.getData();
  },
};
</script>
